import { CircleHelp } from 'lucide-react';

export function PageHeader({ eyebrow, title, description, meta, actions }) {
  return <header className="workspace-header flex min-h-[52px] shrink-0 items-center justify-between gap-4 border-b border-white/8 px-0 pb-2">
    <div className="min-w-0">
      <div className="flex items-center gap-2">
        {eyebrow && <p className="truncate text-[7px] font-black uppercase tracking-[.22em] text-cyan-300/75">{eyebrow}</p>}
        {description && <button type="button" title={description} aria-label={`${title} help`} className="text-slate-700 transition hover:text-cyan-300"><CircleHelp size={12}/></button>}
      </div>
      <div className="mt-1 flex min-w-0 flex-wrap items-center gap-2.5">
        <h1 className="truncate text-[17px] font-black tracking-[-.025em] text-slate-50">{title}</h1>
        {meta}
      </div>
    </div>
    {actions && <div className="flex shrink-0 flex-wrap items-center justify-end gap-2">{actions}</div>}
  </header>;
}
